import { observer } from 'mobx-react'
import React from 'react'
import { getPercent } from '@utils'
import { toPrice } from '@dt/fe-utils'
import { getLevelUpGrowth } from 'common/utils/member'
import './index.scss'

interface IProps {
  coverCardInfo: any;
  onChange: (e: any) => void;
}

const CardInfoModule: React.FC<IProps> = (props: IProps) => {
  const { coverCardInfo, onChange } = props
  return (
    <div className='card-info-module'>
      <div className='card-info'>
        <div className='card-info-item'>
          <div>{i18n.t('mkt.common.integral')}</div>
          <div className='item-num'>{coverCardInfo.integral || '-'}</div>
        </div>
        <div className='line'></div>
        <div className='card-info-item'>
          <div>{i18n.t('mkt.common.balance')}</div>
          <div className='item-num'>{toPrice(coverCardInfo.balance || 0, 2, false)}</div>
        </div>
        <div className='line'></div>
        <div className='card-info-item'>
          <div>{i18n.t('mkt.member.grade')}</div>
          <div className='item-num'>{coverCardInfo?.card?.isLevel ? 'LV ' + (coverCardInfo.card?.level || 1) : '-'}</div>
        </div>
      </div>
      {/* {
        coverCardInfo.card && coverCardInfo.card.nextLevelInfo &&
          <div className='tip'>
            {
              coverCardInfo.card.consumeGrowthOverly && coverCardInfo.card.rechargeGrowthOverly ? (
                <span>{i18n.t('mkt.member.upgrade', { consume: toPrice(changeGrowth(coverCardInfo.card.consumeGrowthGet, coverCardInfo.card.consumeGrowth), 0, false), recharge: toPrice(changeGrowth(coverCardInfo.card.rechargeGrowthGet, coverCardInfo.card.rechargeGrowth), 0, false) })}</span>
              ) : (
                <span>
                  {coverCardInfo.card.consumeGrowthOverly && i18n.t('mkt.member.upgradeCon', { amount: toPrice(changeGrowth(coverCardInfo.card.consumeGrowthGet, coverCardInfo.card.consumeGrowth), 0, false) })}
                  {coverCardInfo.card.rechargeGrowthOverly && i18n.t('mkt.member.upgradeRec', { amount: toPrice(changeGrowth(coverCardInfo.card.rechargeGrowthGet, coverCardInfo.card.rechargeGrowth), 0, false) })}
                </span>
              )
            }
            <span>
              {coverCardInfo.card.nextLevelInfo.discountType === 'memberPrice' && ',' + i18n.t('mkt.member.memberPriceOfMeals')}
              {coverCardInfo.card.nextLevelInfo.discountType === 'discountRate' && ',' + i18n.t('mkt.member.foodDiscount', { discount: format.toDiscount('discountRate', coverCardInfo.card.nextLevelInfo.discountValue) })}
            </span>
          </div>
      } */}
      {
        coverCardInfo.card && coverCardInfo.card.isLevel && (coverCardInfo.card.nextLevelInfo || coverCardInfo.card.level > 1) &&
          <div className='tip'>
            <div data-cypid='mmgToMCardLvDetail' onClick={(e: any) => { onChange(e) }}>
              <span>{coverCardInfo.card?.nextLevelInfo ? i18n.t('mkt.member.upgradePoi', { growth: getLevelUpGrowth(coverCardInfo.card?.nextLevelInfo?.levelGrowth, coverCardInfo.growth) }) : i18n.t('mkt.member.highestGrade')}</span>
              <span className='level-num'>LV{coverCardInfo.card?.nextLevelInfo ? coverCardInfo.card.level + 1 : coverCardInfo.card.level}</span>
              <i className='iconfont icon-chevron-right level-right'></i>
            </div>
            <div className='pro-bar'>
              <div className='pro-bar-bg'></div>
              <div style={{ width: coverCardInfo.card?.nextLevelInfo ? `${getPercent(coverCardInfo.growth, coverCardInfo.card?.nextLevelInfo?.levelGrowth) || 0}%` : '100%' }} className='pro-bar-completed'></div>
            </div>
          </div>
      }
    </div>
  )
}

export default observer(CardInfoModule)
